import { createElement } from 'react';
import { install as install$1 } from '@twind/core';
function install(config, AppComponent = TwindApp, isProduction = 'production' == process.env.NODE_ENV) {
    return install$1(config, isProduction), AppComponent;
}
function TwindApp(props) {
    return createElement(props.Component, props.pageProps);
}
export { install as default };
//# sourceMappingURL=app.js.map
